import React from "react";
import ReactTooltip from "react-tooltip";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Portfolio = () => {
  var settings = {
    dots: false,
    arrow: true,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    draggable: false,
    responsive: [
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          arrow: false,
          autoplay: false,
          draggable: true,
          speed: 300,
          dots: true,
        },
      },
    ],
  };

  return (
    <div className="portfolio_inner my_carousel gallery_zoom">
      <ul data-aos="fade-right" data-aos-duration="1200">
        <Slider {...settings}>
          <li>
            <div className="list_inner">
              <div className="image">
                <a
                  href="https://www.traidies.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="details"
                >
                  <img
                    src="img/portfolio/traidies.png"
                    data-tip
                    data-for="traidies"
                    alt="portfolio"
                  />
                  <ReactTooltip
                    id="traidies"
                    place="bottom"
                    type="light"
                    effect="float"
                    className="tooltip-wrapper"
                  >
                    <div>
                      <h5>Traidies</h5>
                      <span>AI-powered product that turns trading strategy ideas into MetaTrader Expert Advisors.</span><br />
                      <span>From idea to generated MQL5 structure in seconds.</span>
                    </div>
                  </ReactTooltip>
                </a>
              </div>
            </div>
          </li>
          <li>
            <div className="list_inner">
              <div className="image">
                <a
                  href="https://www.paidontime.app/"
                  target="_blank"
                  rel="noreferrer"
                  className="details"
                >
                  <img
                    src="img/portfolio/paidontime.png"
                    data-tip
                    data-for="paidontime"
                    alt="portfolio"
                  />
                  <ReactTooltip
                    id="paidontime"
                    place="bottom"
                    type="light"
                    effect="float"
                    className="tooltip-wrapper"
                  >
                    <div>
                      <h5>PaidOnTime</h5>
                      <span>A product built to solve one of the biggest freelancer problems: getting paid on time without chasing clients after the work is done.</span>
                    </div>
                  </ReactTooltip>
                </a>
              </div>
            </div>
          </li>
          <li>
            <div className="list_inner">
              <div className="image">
                <a
                  href="https://www.bookme.fans/"
                  target="_blank"
                  rel="noreferrer"
                  className="details"
                >
                  <img
                    src="img/portfolio/bookme.png"
                    data-tip
                    data-for="bookme"
                    alt="portfolio"
                  />
                  <ReactTooltip
                    id="bookme"
                    place="bottom"
                    type="light"
                    effect="float"
                    className="tooltip-wrapper"
                  >
                    <div>
                      <h5>BookMe</h5>
                      <span>Creator booking platform that connects fans, brands and creators through a simple booking experience.</span>
                    </div>
                  </ReactTooltip>
                </a>
              </div>
            </div>
          </li>
          <li>
            <div className="list_inner">
              <div className="image">
                <a
                  href="https://www.revwolves.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="details"
                >
                  <img
                    src="img/portfolio/revwolves.png"
                    data-tip
                    data-for="revwolves"
                    alt="portfolio"
                  />
                  <ReactTooltip
                    id="revwolves"
                    place="bottom"
                    type="light"
                    effect="float"
                    className="tooltip-wrapper"
                  >
                    <div>
                      <h5>RevWolves</h5>
                      <span>Business growth platform for scaling software products through referral tracking, seller partnerships and lifetime commissions.</span>
                    </div>
                  </ReactTooltip>
                </a>
              </div>
            </div>
          </li>
          {/* End li */}

          <li>
            <div className="list_inner">
              <div className="image">
                <a
                  href="https://www.ipdynamics.de/en/dynamic-workload/monitoring-reporting"
                  target="_blank"
                  rel="noreferrer"
                  className="details"
                >
                  <img
                    src="img/portfolio/dynamicview.png"
                    data-tip
                    data-for="dynamicview"
                    alt="portfolio"
                  />
                  <ReactTooltip
                    id="dynamicview"
                    place="bottom"
                    type="light"
                    effect="float"
                    className="tooltip-wrapper"
                  >
                    <div>
                      <h5>Dynamic View</h5>
                      <span>Enterprise dashboard for monitoring, reporting and real-time operational insights.</span><br />
                      <span>My work focused on React UI, complex workflows, filters, accessibility and frontend modernization.</span>
                    </div>
                  </ReactTooltip>
                </a>
              </div>
            </div>
          </li>
          {/* End li */}
          <li>
            <div className="list_inner">
              <div className="image">
                <a
                  href="https://www.ipdynamics.de/en/dynamic-workload/video-consulting"
                  target="_blank"
                  rel="noreferrer"
                  className="details"
                >
                  <img
                    src="img/portfolio/dynamicstage.png"
                    data-tip
                    data-for="dynamicstage"
                    alt="portfolio"
                  />
                  <ReactTooltip
                    id="dynamicstage"
                    place="bottom"
                    type="light"
                    effect="float"
                    className="tooltip-wrapper"
                  >
                    <div>
                      <h5>Dynamic Stage</h5>
                      <span>Enterprise video consulting platform for digital customer consultation and multichannel communication.</span><br />
                      <span>My work focused on frontend features, UI improvements, bug fixing and maintainable React development.</span>
                    </div>
                  </ReactTooltip>
                </a>
              </div>
            </div>
          </li>
          {/* End li */}
        </Slider>
      </ul>
    </div>
  );
};

export default Portfolio;
